import React, {  useState, useEffect } from "react";

export default function JStest(props) {
  const correctAnswers = [1, 1, 2, 0, 0, 0, 0, 3, 2, 2, 3, 0, 2, 1, 0, 3, 3, 2, 1, 0, 2, 0, 2, 1, 2];
  const que = {
    q1: {
      string: "1. Which type of JavaScript language is ___?",
      options: ["Object-Oriented", "Object-Based", "Assembly-language", "High-level"],
      ans: 1
    },
    q2: {
      string: "2. Which of the following is a server-side JavaScript object?",
      options: ["Function", "File", "FileUpload", "Date"],
      ans: 1
    },
    q3: {
      string: "3. Which of the following is a valid type of function javascript supports?",
      options: ["named function", "anonymous function", "Both the above", "None of the above"],
      ans: 2
    },
    q4: {
      string: "4. Which of the following is not a valid JavaScript variable name?",
      options: ["2names", "_first_and_last_names", "FirstAndLast", "None of the above"],
      ans: 0
    },
    q5: {
      string: "5. Which symbol is used for comments in JavaScript?",
      options: ["//", "/* */", "#", "$$"],
      ans: 0
    },
    q6: {
      string: "6. What is the output of 'console.log(typeof NaN);'?",
      options: ["Number", "String", "Object", "Undefined"],
      ans: 0
    },
    q7: {
      string: "7. Which method is used to round a number to its nearest integer in JavaScript?",
      options: ["Math.round()", "Math.ceil()", "Math.floor()", "Math.abs()"],
      ans: 0
    },
    q8: {
      string: "8. Which built-in method returns the length of the string?",
      options: ["length()", "size()", "index()", "None of the above"],
      ans: 3
    },
    q9: {
      string: "9. Which of the following function of String object returns the characters in a string between two indexes into the string?",
      options: ["slice()", "split()", "substring()", "substr()"],
      ans: 2
    },
    q10: {
      string: "10. How can you convert the string '123' to an integer in JavaScript?",
      options: ["Number('123')", "parseInt('123')", "Both the above", "None of the above"],
      ans: 2
    },
    q11: {
      string: "11. Which of the following is an advantage of using JavaScript?",
      options: ["Less server interaction", "Immediate feedback to the visitors", "Increased interactivity", "All of the above"],
      ans: 3
    },
    q12: {
      string: "12. How do you create an array in JavaScript?",
      options: ["var arr = []", "var arr = {}", "var arr = ()", "var arr = <>"],
      ans: 0
    },
    q13: {
      string: "13. Which of the following is not a reserved word in JavaScript?",
      options: ["interface", "throws", "program", "short"],
      ans: 2
    },
    q14: {
      string: "14. What will be the output of '2' + 2 in JavaScript?",
      options: ["4", "22", "NaN", "Error"],
      ans: 1
    },
    q15: {
      string: "15. Which company developed JavaScript?",
      options: ["Netscape", "Bell Labs", "Sun Microsystems", "IBM"],
      ans: 0
    },
    q16: {
      string: "16. Which of the following is not a JavaScript data type?",
      options: ["Null", "Undefined", "Boolean", "Float"],
      ans: 3
    },
    q17: {
      string: "17. Which keyword is used to declare a variable in JavaScript?",
      options: ["var", "let", "const", "All of the above"],
      ans: 3
    },
    q18: {
      string: "18. How do you call a function named 'myFunction'?",
      options: ["call function myFunction()", "call myFunction()", "myFunction()", "Call.myFunction()"],
      ans: 2
    },
    q19: {
      string: "19. Which event occurs when the user clicks on an HTML element?",
      options: ["onchange", "onclick", "onmouseclick", "onmouseover"],
      ans: 1
    },
    q20: {
      string: "20. What is the correct syntax for referring to an external script called 'xxx.js'?",
      options: ["<script src='xxx.js'>", "<script href='xxx.js'>", "<script name='xxx.js'>", "<script link='xxx.js'>"],
      ans: 0
    },
    q21: {
      string: "21. How do you write a comment in JavaScript?",
      options: ["'This is a comment", "<!--This is a comment-->", "//This is a comment", "**This is a comment**"],
      ans: 2
    },
    q22: {
      string: "22. Which method is used to add an element to the end of an array?",
      options: ["push()", "pop()", "shift()", "unshift()"],
      ans: 0
    },
    q23: {
      string: "23. What is the correct way to write a JavaScript array?",
      options: ["var colors = 'red', 'green', 'blue'", "var colors = (1:'red', 2:'green', 3:'blue')", "var colors = ['red', 'green', 'blue']", "var colors = {1:'red', 2:'green', 3:'blue'}"],
      ans: 2
    },
    q24: {
      string: "24. How do you find the number with the highest value of x and y?",
      options: ["Math.ceil(x, y)", "Math.max(x, y)", "Math.floor(x, y)", "Math.round(x, y)"],
      ans: 1
    },
    q25: {
      string: "25. Which operator is used to assign a value to a variable?",
      options: ["*", "-", "=", "+"],
      ans: 2
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>JAVASCRIPT <span>Skill</span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
